import * as React from 'react';
import { Box, Button } from '@mui/material';
import { Chip, Grid } from '@material-ui/core';
import { getRequestStatusName } from '../enum-translates';
import { CustomLabel } from './custom-label';
import { WorkStatus } from '../models/work-status';
import { Theme, useTheme } from '@mui/material/styles';

export const getStatusColor = (theme: Theme, status: string) => {
    switch (status) {
        case 'Free':
            return theme.palette.blue['600'];
        case 'InProgress':
            return theme.palette.orange['500'];
        case 'UnderDuty':
            return theme.palette.purple['700'];
        case 'Closed':
            return theme.palette.success['800'];
        default:
            return '-';
    }
};

interface StatusChangeButtonProps {
    status: string;
    changeStatus: (status: string) => {};
}

export const StatusChangeButton = (props: StatusChangeButtonProps) => {
    const theme = useTheme();
    return (
        <Button
            variant={'contained'}
            sx={{
                backgroundColor: getStatusColor(theme, props.status),
                transition: 'all 0.4s',
                '&:hover': {
                    transform: 'scale(97%)',
                    backgroundColor: getStatusColor(theme, props.status),
                },
            }}
            onClick={async () => {
                await props.changeStatus(props.status);
            }}
        >
            {getRequestStatusName(props.status)}
        </Button>
    );
};

export const StatusHistory = ({ history }: { history: WorkStatus[] }) => {
    const theme = useTheme();
    return (
        <Box>
            <CustomLabel>Státusz történet</CustomLabel>
            <Grid container style={{ fontWeight: 700, margin: '15px 0' }}>
                <Grid xs={3}>Módosító</Grid>
                <Grid xs={3}>Előző státusz (miről)</Grid>
                <Grid xs={3}>Megadott státusz (mire)</Grid>
                <Grid xs={3}>Módosítás ideje</Grid>
            </Grid>
            {history.map((status, index) => {
                return (
                    <Grid
                        container
                        style={{
                            padding: '15px 0',
                            borderTop: '1px solid white',
                        }}
                        key={index}
                    >
                        <Grid xs={3}>
                            {status.admin?.name} ({status.admin?.email})
                        </Grid>
                        <Grid xs={3}>
                            <Chip
                                style={{
                                    backgroundColor: getStatusColor(
                                        theme,
                                        status.previous as unknown as string
                                    ),
                                    color: '#FFF',
                                }}
                                label={getRequestStatusName(
                                    status.previous as unknown as string
                                )}
                            />
                        </Grid>
                        <Grid xs={3}>
                            <Chip
                                style={{
                                    backgroundColor: getStatusColor(
                                        theme,
                                        status.status as unknown as string
                                    ),
                                    color: '#FFF',
                                }}
                                label={getRequestStatusName(
                                    status.status as unknown as string
                                )}
                            />
                        </Grid>
                        <Grid xs={3}>
                            {status.lastModified
                                ? `${status.lastModified.substring(0, 10)} ${status.lastModified.substring(11, 19)}`
                                : ''}
                        </Grid>
                    </Grid>
                );
            })}
        </Box>
    );
};
